import { Link } from "react-router-dom";
import Logo from "layout/Footer/Logo/Logo";
import Copyright from "layout/Footer/Copyright/Copyright";
import "layout/Footer/Footer/Footer.scss";
import { ReactComponent as IconExtLink } from "assets/images/icons/ext-link.svg";

function Footer() {
  return (
    <footer>
      <div className={ 'footer' }>
        <div className={ 'wrapper--fluid grid' }>
          <div className={ 'footer__logo' }>
            <Logo/>
          </div>
          <div className={ 'footer__links' }>
            <ul>
              <li><Link to="/help">Help</Link></li>
              <li><Link to="/huisregels">Huisregels</Link></li>
              <li><Link to="/handleiding">Handleiding</Link></li>
              <li>
                <a href={ 'https://www.anbo-pcob.nl' } target={ '_blank' } rel={ 'noreferrer' } className={'ext'}>
                  Over ANBO-PCOB
                  <IconExtLink/>
                </a>
              </li>
              <li><Link to="/contact">Contact</Link></li>
              <li>
                <a href={ 'https://www.anbo-pcob.nl' } target={ '_blank' } rel={ 'noreferrer' } className={'ext'}>
                  anbo-pcob.nl
                  <IconExtLink/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Copyright/>
    </footer>
  )
}

export default Footer;
